import styled from "styled-components";

export const TwoColumnsFormLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
`;
